import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-member-loader',
  templateUrl: './member-loader.component.html',
  styleUrls: ['./member-loader.component.scss']
})
export class MemberLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
